import * as React from 'react';
import { withTranslation } from 'react-i18next';

const DonorHeaderComponent = (props: any) => {
  const { t } = props;

  return (
    <div className="donation-management">
      <section id="content-header">
        <div className="aw_container aw_full_width aw_content_header_module pt16 pb40 donation-header">
          <div className="aw_row aw_max_content_width">
            <div className="col_12">
              <p id="breadcrumbs" className="aw_breadcrumb aw_breadcrumb_true mb80 mb_mobile_40 left">
                <span>
                  <span className="aw_pxsmall">
                    <a href="/">{t('home_page')}</a>
                    <i className="aw_icon"></i>
                    <span className="breadcrumb_last" aria-current="page">
                      {t('header_label')}
                    </span>
                  </span>
                </span>
              </p>
              <h1 className="h3 content-header-text mb24 donation-header-content left">
                {t('name')}
                <br />
                {t('primary_headline')}
              </h1>
            </div>
          </div>
        </div>{' '}
      </section>
    </div>
  );
};

export default withTranslation('language')(DonorHeaderComponent);
